import React, { useState, useCallback, useEffect } from "react";
import {
  AccountSummaryWrapper,
  Container,
  Icon,
  Input,
  Search,
  TabContainer,
  TabLinkContainer,
} from "../../pages/Dashboard/styles/dashboard.style";
import GlobalStyles from "../../assets/globalStyle";
import { BsSearch } from "react-icons/bs";
import Loader from "../pageLoader/loader";
import { useSelector } from "react-redux";
import ErrorService from "../../services/errorService";
import hostelApi from "../../services/hostel";
import colors from "../../assets/colors.json";
import { AuthButton } from "../../pages/auth/Login.style";
import { LiaEllipsisVSolid } from "react-icons/lia";
import Modal from "../modal/Modal";
import { paginateData } from "../../services/utils";
import Pagination from "../pagination_one/pagination";
import { MenuItem, MenuList } from "@mui/material";
import Popover from "@mui/material/Popover";
import { Box } from "@mui/system";
import Select from "../select/select";
import { toast } from "react-toastify";
import AssignHouseComponent from "./AssigHouseComponent";

const AssignHouse = () => {
  const { admToken, user} = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [openAssignHouseModal, setOpenAssignHouseModal] = useState(false);
  const [houses, setHouses] = useState([]);
  const [classes, setClasses] = useState([]);
  const [assignedStudents, setAssignedStudents] = useState([]);
  const [selectedHouse, setSelectedHouse] = useState(null);
  const [selectedClass, setSelectedClass] = useState({
    id: "",
    name: "",
  });
  const [list, setList] = useState([]);
  const [itemOffSet, setitemOffSet] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [sQuery, setSQuery] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleAnchorClick = (event, house) => {
    setAnchorEl(event.currentTarget);
    setSelectedHouse(house);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  
  const filterSearch = async (e) => {
    const queryRegex = new RegExp(e.target.value, "i");
    const arr = assignedStudents.filter((item) => {
      return Object.values(item).some((val) => queryRegex.test(val));
    });
    setList(arr);
    setPageCount(0);
  };

  const getHouses = useCallback(async () => {
    setLoading(true);
    try {
      const res = await hostelApi.getHouses(admToken, user.schoolId);
      if (res.status && res.statusCode === 2) {
        setHouses(res.data);
      }
      res.status === 500 ||
        res.status === 400 ||
        (!res.status && ErrorService.displayErrorAlert(res));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [admToken, user.schoolId]);

  const getClasses = useCallback(async () => {
    try {
      const res = await hostelApi.getClasses(admToken);
      if (res?.status && res?.statusCode === 2) {
        setClasses(res.data || []);
      } else {
        console.log("Failed to fetch classes:", res);
      }
    } catch (error) {
      console.log("Error fetching classes:", error);
    }
  }, [admToken]);

  const getAssignedStudents = useCallback(async (classId) => {
    if (!classId) {
      toast.error("Please select a class first");
      return;
    }

    setLoading(true);
    try {
      const res = await hostelApi.getStudentsAssignedToHouse(admToken, classId);
      if (res?.status && res?.statusCode === 2) {
        setAssignedStudents(res.data || []);
        toast.success(`Found ${res.data?.length || 0} assigned students`);
      } else {
        console.log("Failed to fetch assigned students:", res);
        setAssignedStudents([]);
        toast.error("Failed to fetch assigned students");
      }
    } catch (error) {
      console.log("Error fetching assigned students:", error);
      setAssignedStudents([]);
      toast.error("Error fetching assigned students");
    } finally {
      setLoading(false);
    }
  }, [admToken]);

  useEffect(() => {
    getHouses();
    getClasses();
  }, [getHouses, getClasses]);

  const resetData = () => {
    setCurrentPage(1);
    paginateData(assignedStudents, setList, 1, itemOffSet, setitemOffSet, setPageCount);
  };

  useEffect(() => {
    paginateData(
      assignedStudents,
      setList,
      currentPage,
      itemOffSet,
      setitemOffSet,
      setPageCount,
      10
    );
  }, [currentPage, assignedStudents, itemOffSet]);

  const handleUnassignStudents = async () => {

    try {
      setLoading(true);
      const data = {
        houseId: selectedHouse.houseId,
        classId: selectedClass.id,
        studentId: [selectedHouse.studentId],
      };

      const res = await hostelApi.unallocateHouseFromStudents(admToken, data);
      
      if (res?.status && res?.statusCode === 2) {
        toast.success(res.message || "Student unassigned successfully");
        getAssignedStudents(selectedClass.id);
        handleClose();
      } else if (res?.status === 500 || res?.status === 400 || !res?.status) {
        ErrorService.displayErrorAlert(res);
        console.log(res);
      }
    } catch (error) {
      console.log("Error unassigning student:", error);
      toast.error("Failed to unassign student");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <GlobalStyles />
      {openAssignHouseModal && (
        <Modal
          content={
            <AssignHouseComponent
              setOpenAssignHouseModal={setOpenAssignHouseModal}
              getHouses={getHouses}
            />
          }
          size="large"
          onClose={setOpenAssignHouseModal}
          setOpenAssignHouseModal={setOpenAssignHouseModal}
          getHouses={getHouses}
        />
      )}

      <div className="flex justify-end mb-5">
        <AuthButton
          onClick={() => setOpenAssignHouseModal(true)}
          bg={colors.primary}
          className="!rounded-md"
        >
          Assign House
        </AuthButton>
      </div>
      <div className="mb-6 p-4 bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="flex flex-col md:flex-row gap-4 items-end">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Select Class
            </label>
            <Select
              title="Select Class"
              index="name"
              selected={selectedClass.id}
              thirdOption="id"
              options={classes}
              setSelected={(val) => {
                setSelectedClass({
                  id: val.id,
                  name: val.name,
                });
              }}
            />
          </div>
          <AuthButton
            onClick={() => getAssignedStudents(selectedClass.id)}
            bg={colors.primary}
            className="!rounded-md"
            disabled={!selectedClass.id || loading}
          >
            {loading ? "Loading..." : "View Assigned Students"}
          </AuthButton>
        </div>
      </div>
      <TabContainer
        style={{
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
          paddingBottom: "0px",
        }}
      >
        <TabLinkContainer bg="rgb(238, 224,241)">
          <Input>
            <Icon>
              <BsSearch />
            </Icon>
            <Search
              type="text"
              placeholder="Search For Assigned Students"
              value={sQuery}
              onChange={(e) => {
                setSQuery(e.target.value);
                if (e.target.value.length > 2) {
                  filterSearch(e);
                }

                if (e.target.value === "") {
                  resetData();
                }
              }}
            />
          </Input>
        </TabLinkContainer>
        <AccountSummaryWrapper pt="0px">
          {loading ? (
            <Loader />
          ) : (
            <Box>
              <table
                style={{
                  borderRadius: "0px",
                  borderBottomLeftRadius: "20px",
                  borderBottomRightRadius: "20px",
                }}
              >
                <tr
                  className="tabel-head"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                  }}
                >
                  <th className="text-[0.75rem] xl:text-[1.1rem]">S/N</th>
                  <th className="text-[0.75rem] xl:text-[1.1rem]">Student Name</th>
                  <th className="text-[0.75rem] xl:text-[1.1rem]">House Name</th>
                  <th className="text-[0.75rem] xl:text-[1.1rem]">Class</th>
                  <th className="text-[0.75rem] xl:text-[1.1rem]">Actions</th>
                </tr>
                {list.length > 0 ? (
                  list.map((student, index) => (
                    <React.Fragment key={index}>
                      <tr className="relative">
                        <td className="text-[0.75rem] xl:text-[1rem]">
                          {index + 1}
                        </td>
                        <td className="text-[0.75rem] xl:text-[1rem]">
                          {student.name || `Student ${index + 1}`}
                        </td>
                        <td className="text-[0.75rem] xl:text-[1rem]">
                          {student.houseName}
                        </td>
                        <td className="text-[0.75rem] xl:text-[1rem]">
                          {student.className || student.class_name || selectedClass.name || "N/A"}
                        </td>
                        <td className="text-[0.75rem] xl:text-[1rem]">
                          <button onClick={(e) => handleAnchorClick(e, student)}>
                            <LiaEllipsisVSolid className="w-6 h-6" />
                          </button>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center py-8 text-gray-500">
                      {selectedClass.id 
                        ? "No assigned students found for this class" 
                        : "Please select a class and click 'View Assigned Students'"
                      }
                    </td>
                  </tr>
                )}
              </table>
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <Box
                  sx={{
                    bgcolor: "#671E78",
                    color: "#fff",
                    fontFamily: "Gilroy-Regular",
                    px: 3,
                  }}
                >
                  <MenuList sx={{ fontFamily: "Gilroy-Regular" }}>
                    <MenuItem
                      onClick={() => {
                        handleUnassignStudents();
                      }}
                    >
                      Unassign
                    </MenuItem>
                  </MenuList>
                </Box>
              </Popover>
            </Box>
          )}
        </AccountSummaryWrapper>
      </TabContainer>
      {pageCount > 1 && (
        <div
          style={{
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          <Pagination
            pageCount={pageCount > 1 && pageCount}
            range={3}
            setCurrentPage={setCurrentPage}
          />
        </div>
      )}
    </Container>
  );
};

export default AssignHouse;
